import { FC } from 'react';
import { useNavigate } from '@tanstack/react-router';
import { ArrowUpRight, FileText } from 'lucide-react';
import { useGetEvaluationQuery } from '@teachur/http-client';

import { TRANSCRIPTS_ROUTE } from '../../lib/routes';

// Shown while the totals are loading or unavailable, so a missing value never reads as 0.
const UNKNOWN_CREDITS = '—';

export const TranscriptSummaryCard: FC = () => {
  const navigate = useNavigate();
  const { data } = useGetEvaluationQuery();
  const official = data?.officialTotal ?? UNKNOWN_CREDITS;
  const unofficial = data?.unofficialTotal ?? UNKNOWN_CREDITS;

  const onViewTranscripts = () => navigate({ to: TRANSCRIPTS_ROUTE });

  return (
    <div className="grid grid-cols-1 overflow-hidden rounded-xl border border-(--neutral-black-NB200) bg-(--neutral-white-NW1000) sm:grid-cols-[1fr_1fr_1fr_auto]">
      <div className="flex items-center gap-3 p-4">
        <span className="flex size-9 shrink-0 items-center justify-center rounded-md bg-(--success-S200)!">
          <FileText className="size-4 text-(--success-S700)" />
        </span>
        <div className="flex flex-col">
          <span className="[font-size:var(--fs-l5)]! uppercase tracking-wide font-medium text-(--neutral-black-NB600)!">
            Academic record
          </span>
          <span className="[font-size:var(--fs-p3)]! font-bold text-(--neutral-black-NB900)!">
            Transcript summary
          </span>
        </div>
      </div>

      <div className="flex flex-col justify-center gap-1 border-t border-(--neutral-black-NB200) p-4 sm:border-l sm:border-t-0">
        <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB600)!">
          Official credits
        </span>
        <span className="[font-size:var(--fs-h6)]! font-bold text-(--neutral-black-NB900)!">
          {official}
        </span>
      </div>

      <div className="flex flex-col justify-center gap-1 border-t border-(--neutral-black-NB200) p-4 sm:border-l sm:border-t-0">
        <span className="[font-size:var(--fs-l5)]! text-(--neutral-black-NB600)!">
          Unofficial credits
        </span>
        <span className="[font-size:var(--fs-h6)]! font-bold text-(--neutral-black-NB900)!">
          {unofficial}
        </span>
      </div>

      <button
        type="button"
        onClick={onViewTranscripts}
        className="flex cursor-pointer items-center justify-between gap-3 bg-(--primary-O900) p-4 text-left text-(--neutral-white-NW1000)! sm:min-w-40"
      >
        <span className="[font-size:var(--fs-b4)]! font-semibold">View all transcripts</span>
        <span className="flex size-7 items-center justify-center rounded-full border border-(--primary-O500) bg-(--neutral-white-NW1000)/25">
          <ArrowUpRight className="size-4" />
        </span>
      </button>
    </div>
  );
};
